import React, { useContext, useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import UsernameContext from '../auth/UsernameContext';
import axios from 'axios'; // Import Axios or use the configured instance
import { useNavigate } from 'react-router-dom';
// import InfosysLogo from '../../assets/infosys- White.svg'; // Adjust the path to your SVG file
import InfosysLogo from '../../assets/Fidrox white png.png'; // Adjust the path to your SVG file


const TopbarContainer = styled.div`
  width: 100%;
  height: 52px;
  background-color: #F3F3F3;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 24px;
  font-weight: bold;
  color: #293495;
  position: fixed;
  top: 0;
  z-index: 1000;
  padding: 0 0px;
  @media (max-width: 768px) {
    font-size: 20px;
    padding: 10px;
  }
`;

const LeftText = styled.div`

  width: 210px;
  background-color: rgb(24, 62, 159) !important;
  padding: 3px 2px 5px 13px;
  display: flex;
  justify-content: space-around;
`;

const CenterText = styled.div`
  flex: 1;
  text-align: center;
  font-size: 24px;
  text-transform: uppercase;
`;

const RightContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  right: 37px;
`;

// const Badge = styled.div`
//   background: linear-gradient(135deg, #FFFFFF, #E9E9E9);
//   color: #293495;
//   border: 2px solid #293495;
//   border-radius: 50%;
//   width: 35px;
//   height: 35px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   font-size: 16px;
//   margin-right: 10px;
// `;

const Badge = styled.div`
  background: linear-gradient(135deg, #FFFFFF, #E9E9E9);
  border: 2px solid #293495;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }
`;

const UserName = styled.div`
  font-size: 16px;
  line-height: 1;
  font-family: 'Segoe UI', Semibold;
`;

const SelectedRoleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;
`;

const SelectedRole = styled.div`
  font-size: 12px;
  color: #707070;
`;

const DropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Dropdown = styled.div`
  position: relative;
  display: inline-block;
`;

const DropdownContent = styled.div`
  display: ${props => (props.show ? 'block' : 'none')};
  position: absolute;
  background-color: #fff;
  min-width: 160px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
  z-index: 1;
  right: 0;
  font-size: 13px;
  padding: 10px;
  border-radius: 5px; /* Add rounded corners */
  margin-top: 5px; /* Add space between button and dropdown */
  transition: all 0.3s ease; /* Smooth transition */
`;

const DropdownButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 8px 12px; /* Add padding for better click area */
  background-color: #F3F3F3; /* Matching background */
  border-radius: 5px; /* Rounded corners */
  &:hover {
    background-color: #E0E0E0; /* Light gray on hover */
  }
`;

const DropdownIcon = styled.span`
  font-size: 10px;
  margin-left: 8px;
`;

const RoleOption = styled.p`
  margin: 5px 0; /* Spacing between options */
  padding: 8px 12px; /* Padding for options */
  cursor: pointer;
  border-radius: 5px; /* Rounded corners for options */
  transition: background-color 0.2s ease; /* Smooth hover effect */
  
  &:hover {
    background-color: #D9D9D9; /* Highlight option on hover */
  }
`;

const TopNavBar = ({ setSelectedRole: setAppSelectedRole }) => {
  const { username } = useContext(UsernameContext);
  const [employeeName, setEmployeeName] = useState('');
  const [employeeId, setEmployeeId] = useState('');
  const [roles, setRoles] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [localSelectedRole, setLocalSelectedRole] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const savedRole = localStorage.getItem('selectedRole');
    if (savedRole) {
      setLocalSelectedRole(savedRole);
      setAppSelectedRole(savedRole);
      console.log('Retrieved role from localStorage:', savedRole);
    }
  }, [setAppSelectedRole]);

  const handleDropdownToggle = () => {
    setShowDropdown(!showDropdown);
  };

  const handleRoleSelect = (role) => {
    setLocalSelectedRole(role.txtRoles); // Set the role name
    setAppSelectedRole(role.txtRoles); // Update the selected role in the parent component
    setShowDropdown(false);
    localStorage.setItem('selectedRole', role.txtRoles);
    localStorage.setItem('selectedRoleId', role.roleId); // Save the selected role to localStorage

    // Log selected role details
    console.log('Selected role object:', role);
    navigate(role.defaultUrl, { state: { roleName: role.txtRoles, roleId: role.roleId } });
    setTimeout(() => {
      window.location.reload();
    }, 200);
  };
  const storedUsername = localStorage.getItem('loginUsername');

  useEffect(() => {
    if (storedUsername) {
      fetchEmployeeMail(storedUsername);
    }
  }, [storedUsername]);

  const fetchEmployeeMail = async (empEmail) => {
    try {
      const response = await axios.get(`/Employee/Employee/${empEmail}`);
      const empId = response.data.id;
      console.log("Employee details", response.data);
      const responseB = await axios.get(`/User/UserDets/${empEmail}`);
      console.log('response', responseB.data);
      if (responseB.data.length > 0) {

        localStorage.setItem('USERID', responseB.data[0].id)
      } else {
        console.error('No user data found for username:', employeeName);
        // Optionally handle case where no data is found
      }


      setEmployeeName(response.data.employeeName);
      setEmployeeId(empId);
      fetchEmployeeRoles(empId);


      console.log('employeeName', response.data.employeeName);
      localStorage.setItem('employeeName', response.data.employeeName);

      console.log('employeeId', empId);
      localStorage.setItem('employeeId', empId);
    } catch (error) {
      console.error('Error fetching employee email:', error);
    }
  };
  // const fetchEmployeeMailM = async () => {
  //   try {
  //     const response = await axios.get(`/User/UserDets/${employeeName}`);
  //     console.log('response', response.data);
  //     if (response.data.length > 0) {

  //       localStorage.setItem('USERID', response.data[0].id)
  //     } else {
  //       console.error('No user data found for username:', employeeName);
  //       // Optionally handle case where no data is found
  //     }

  //   } catch (error) {
  //     console.error('Error fetching employee email:', error);
  //   }
  // };
  // fetchEmployeeMailM()

  const fetchEmployeeRoles = async (empId) => {
    try {
      const response = await axios.get(`/RoleManagement/GetRoles`, { params: { empId } });
      const rolesData = response.data;
      if (rolesData) {
        localStorage.setItem('roleID', rolesData[0].roleId)
      }

      if (rolesData && rolesData.length > 0) {
        setRoles(rolesData); // Set the entire role objects in the state

        if (rolesData.length > 0 && !localStorage.getItem('selectedRole')) {
          setLocalSelectedRole(rolesData[0].txtRoles);
          setAppSelectedRole(rolesData[0].txtRoles);
          localStorage.setItem('selectedRole', rolesData[0].txtRoles);
          console.log('Setting initial role:', rolesData[0].txtRoles);
        }
      } else {
        setRoles([]);
        setLocalSelectedRole('');
      }
    } catch (error) {
      console.error('Error fetching employee roles:', error);
    }
  };

  useEffect(() => {
    console.log('Roles:', roles);
    console.log('Selected Role:', localSelectedRole);
  }, [roles, localSelectedRole]);
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <TopbarContainer>
      <LeftText><img src={InfosysLogo} alt="Infosys Logo" style={{ width: '162px', height: '48px' }} />
      </LeftText>
      <CenterText>Visitor Management System</CenterText>
      <RightContainer>
        {/* <Badge>{employeeName ? employeeName.charAt(0) : ''}</Badge> */}
        <Badge>
          <img src="https://i.imgur.com/6VBx3io.png" alt="User Profile" />
        </Badge>
        <Dropdown ref={dropdownRef}>
          <DropdownButton onClick={handleDropdownToggle}>
            <UserName>{employeeName}</UserName>
            <SelectedRoleContainer>
              <SelectedRole>{localSelectedRole}</SelectedRole>
              <DropdownIcon>&#9660;</DropdownIcon>
            </SelectedRoleContainer>
          </DropdownButton>
          <DropdownContent show={showDropdown}>
            {roles.map(role => (
              <RoleOption key={role.roleId} onClick={() => handleRoleSelect(role)}>
                {role.txtRoles}
              </RoleOption>
            ))}
          </DropdownContent>
        </Dropdown>
      </RightContainer>
    </TopbarContainer>
  );
};

export default TopNavBar;
